var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHandDepart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0278 11.4775C13.1973 11.4775 15.7666 8.9082 15.7666 5.73877C15.7666 2.56933 13.1973 0 10.0278 0C6.8584 0 4.28906 2.56933 4.28906 5.73877C4.28906 8.9082 6.8584 11.4775 10.0278 11.4775ZM13.4342 4.37672C13.788 3.95264 13.7311 3.32205 13.307 2.96824C12.8829 2.61443 12.2523 2.67139 11.8985 3.09546L9.27073 6.24514L7.77573 4.91911C7.36256 4.55264 6.73052 4.59049 6.36405 5.00367C5.99757 5.41684 6.03543 6.04887 6.4486 6.41535L8.7147 8.42533C8.91704 8.6048 9.18345 8.69466 9.45315 8.6744C9.72286 8.65415 9.97285 8.52551 10.1461 8.31784L13.4342 4.37672Z",
    fill: "#3AB54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.618 19.1835H8.12068C7.83135 18.9482 6.49998 16.1402 5.87046 14.7656C5.75438 14.4736 5.64211 13.8196 6.12161 13.5393C6.60111 13.2589 6.95129 13.4778 7.06644 13.6223C7.3279 13.9631 7.92505 14.7204 8.22199 15.023C8.51893 15.3255 8.60846 14.9775 8.61611 14.7656V8.62186C8.61936 8.24531 8.8011 7.49219 9.50213 7.49219C10.2032 7.49219 10.4498 8.04373 10.4855 8.3195L10.6312 11.9339C10.6467 11.4956 10.8351 10.9188 11.5176 10.9188C12.2731 10.9188 12.5047 11.6742 12.5361 12.1482C12.5365 11.6773 12.698 10.926 13.3675 10.9188C14.0997 10.9111 14.4321 11.8178 14.5067 12.2722C14.5197 11.9997 14.6897 11.4547 15.2661 11.4547C15.8425 11.4547 16.0054 11.9085 16.0147 12.1355C16.0844 12.9892 16.2236 14.8462 16.2236 15.4444C16.2236 16.0425 16.1723 16.4635 16.1467 16.5992L15.618 19.1835Z",
    fill: "#FFD0B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.48828,
    y: 19.0054,
    width: 8.6263,
    height: 2.99418,
    rx: 0.5,
    fill: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHandDepart);
export default __webpack_public_path__ + "static/media/ic-hand-depart.031f21bd0b2c08a29b9ec12bd917cd05.svg";
export { ForwardRef as ReactComponent };